var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"width":"100%","height":"100%"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.empty),expression:"!empty"}],ref:"chart",staticClass:"canvas-wrapper"}),_c('Empty',{directives:[{name:"show",rawName:"v-show",value:(_vm.empty),expression:"empty"}]})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }